import React from "react";
import { STATUS_META, PRIORITY_META, METHOD_META, platformIcon, FORMAT_ICON } from "../../lib/ops";

function Chip({ meta, testid }) {
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide"
      style={{ color: meta.color, background: meta.bg }}
    >
      {meta.label}
    </span>
  );
}

export const StatusPill = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.ready;
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide"
      style={{ color: meta.color, background: meta.bg }} data-testid={`status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} /> {meta.label}
    </span>
  );
};

export const PriorityPill = ({ priority }) => <Chip meta={PRIORITY_META[priority] || PRIORITY_META.low} testid={`priority-${priority}`} />;

export const MethodBadge = ({ method }) => {
  const meta = METHOD_META[method] || METHOD_META.MANUAL;
  return <Chip meta={meta} testid={`method-${method}`} />;
};

export const PlatformIcon = ({ platform, size = 15, className = "" }) => {
  const Icon = platformIcon(platform);
  return <Icon size={size} strokeWidth={1.75} className={className} />;
};

export const FormatTag = ({ format }) => {
  const Icon = FORMAT_ICON[format] || FORMAT_ICON.Feed;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-ink-2">
      <Icon size={14} strokeWidth={1.75} /> {format}
    </span>
  );
};
